__turbopack_context__.v({
  "decorations": "CardDecorationModal-module-scss-module__WFus3a__decorations",
  "hideMobile": "CardDecorationModal-module-scss-module__WFus3a__hideMobile",
  "preview": "CardDecorationModal-module-scss-module__WFus3a__preview",
  "showMobile": "CardDecorationModal-module-scss-module__WFus3a__showMobile",
});
